import { z } from 'zod';

const userIdSchema = z.union([z.string(), z.number()]).transform((value) => value.toString());

export const userStatusSchema = z.object({
  userId: userIdSchema,
  role: z.string().optional(),
  status: z.enum(['ONLINE', 'OFFLINE', 'AWAY']),
  availabilityStatus: z.enum(['AVAILABLE', 'BUSY', 'OFFLINE']).optional(),
  lastSeen: z.preprocess((arg) => (typeof arg === 'string' ? new Date(arg) : arg), z.date()),
  lastHeartbeat: z.preprocess((arg) => (typeof arg === 'string' ? new Date(arg) : arg), z.date()).optional()
});

export const presenceStatsSchema = z.object({
  totalOnline: z.number().int().nonnegative(),
  totalDoctorsAvailable: z.number().int().nonnegative(),
  totalPatients: z.number().int().nonnegative(),
  totalDoctors: z.number().int().nonnegative(),
  totalAdmins: z.number().int().nonnegative()
});

export const waitingRoomStatusSchema = z.object({
  teleconsultationId: z.union([z.string(), z.number()]),
  patientId: z.number(),
  patientName: z.string().optional(),
  urgency: z.string().optional(),
  position: z.number().int().nonnegative(),
  estimatedWaitTime: z.number().int().nonnegative(),
  totalPatients: z.number().int().nonnegative().optional(),
  doctorsAvailable: z.number().int().nonnegative().optional(),
  status: z.enum(['WAITING', 'CALLED', 'IN_CONSULTATION']).optional()
});

export type UserStatusValidated = z.infer<typeof userStatusSchema>;
export type PresenceStatsValidated = z.infer<typeof presenceStatsSchema>;
export type WaitingRoomStatusValidated = z.infer<typeof waitingRoomStatusSchema>;

